<div class="auto-complete">
	<label [for]="identifier" class="input-label" [translate]="labelKey" *ngIf="labelKey"> </label>
	<input
		autoComplete="off"
		[ngModel]="activeFilters.get(identifier)"
		(ngModelChange)="activeFilters.set(identifier, $event)"
		[id]="identifier"
		[name]="identifier"
		type="search"
		class="search"
		[attr.placeholder]="placeholder | translate"
		(keyup)="onFilterKeyUp($any($event.target).value)"
	/>
	<!-- stagesAutofocus does not work on iPad -->
</div>
<div class="info"></div>
